import { render, staticRenderFns } from "./pages20.vue?vue&type=template&id=b224e112&"
import script from "./pages20.vue?vue&type=script&lang=js&"
export * from "./pages20.vue?vue&type=script&lang=js&"
import style0 from "./pages20.vue?vue&type=style&index=0&id=b224e112&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports